import Vue from 'vue'
import Talk from "@/talk/Talk.vue";
import VueObserveVisibility from 'vue-observe-visibility';

// Syntax highlighting
import 'prismjs'
import 'prismjs/themes/prism.css'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-yaml'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-diff'

// Bootstrap
import './init'
import './talk/talk.css'

// See https://github.com/Akryum/vue-observe-visibility
Vue.use(VueObserveVisibility)

new Vue({
  render: h => h(Talk),
}).$mount('#app');
